import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://deyfreshsignature.com";
const defaults = {
  "/": ["Dey Fresh Signature | Premium Unisex Salon in Ajah, Lagos", "Premium unisex salon in Ajah for hair styling, braids, locs, barbering, nails, pedicure, lashes and facials. Visit Dey Fresh Signature on Ogombo Road."],
  "/services": ["Salon Services in Ajah | Dey Fresh Signature", "Explore hair styling, braids, locs, barbering, nails, pedicure, lashes and facial services at Dey Fresh Signature in Ajah, Lagos."],
  "/gallery": ["Hair, Barbering & Beauty Gallery | Dey Fresh Signature", "Explore selected hair, locs, grooming, nails and beauty work from Dey Fresh Signature, a premium unisex salon in Ajah, Lagos."],
  "/about": ["About Dey Fresh Signature | Unisex Salon in Ajah", "Learn about Dey Fresh Signature, our approach to personal service, professional hair, grooming, nails and beauty care in Ajah, Lagos."],
  "/contact": ["Contact Dey Fresh Signature | Salon in Ajah, Lagos", "Contact Dey Fresh Signature at Shop H9, Ojaja Mall, Ogombo Road, Ajah. Chat on WhatsApp, call, get directions or book your salon appointment."],
};

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, description] = defaults[pathname] || defaults["/"];
    const canonical = `${SITE}${pathname === "/" ? "/" : pathname}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;
  }, [pathname]);
  return null;
}
